const lookUpTable = Array(256)
    .fill('')
    .map((_, i) => (i < 16 ? '0' : '') + i.toString(16));
const formatUUID = (randomValues) => lookUpTable[randomValues[0] & 0xff] +
    lookUpTable[(randomValues[0] >> 8) & 0xff] +
    lookUpTable[(randomValues[0] >> 16) & 0xff] +
    lookUpTable[(randomValues[0] >> 24) & 0xff] +
    '-' +
    lookUpTable[randomValues[1] & 0xff] +
    lookUpTable[(randomValues[1] >> 8) & 0xff] +
    '-' +
    lookUpTable[((randomValues[1] >> 16) & 0x0f) | 0x40] +
    lookUpTable[(randomValues[1] >> 24) & 0xff] +
    '-' +
    lookUpTable[(randomValues[2] & 0x3f) | 0x80] +
    lookUpTable[(randomValues[2] >> 8) & 0xff] +
    '-' +
    lookUpTable[(randomValues[2] >> 16) & 0xff] +
    lookUpTable[(randomValues[2] >> 24) & 0xff] +
    lookUpTable[randomValues[3] & 0xff] +
    lookUpTable[(randomValues[3] >> 8) & 0xff] +
    lookUpTable[(randomValues[3] >> 16) & 0xff] +
    lookUpTable[(randomValues[3] >> 24) & 0xff];
const getCryptoRandomVariables = () => {
    const randomValues = new Uint32Array(4);
    window.crypto.getRandomValues(randomValues);
    return randomValues;
};
// This should only be used as fallback if window.crypto.getRandomValues does not exist
const getMathRandomVariables = () => {
    const randomValues = new Uint32Array(4);
    randomValues[0] = (Math.random() * 0x100000000) >>> 0;
    randomValues[1] = (Math.random() * 0x100000000) >>> 0;
    randomValues[2] = (Math.random() * 0x100000000) >>> 0;
    randomValues[3] = (Math.random() * 0x100000000) >>> 0;
    return randomValues;
};
/**
 * Utility function to generate UUID
 * @return {string} - a generated UUID
 */
export function generateUUID() {
    const randomValues = window.crypto && window.crypto.getRandomValues
        ? getCryptoRandomVariables()
        : getMathRandomVariables();
    return formatUUID(randomValues);
}
//# sourceMappingURL=UUID.js.map